import {IHttpPromiseCallbackArg, IHttpService, IRequestShortcutConfig} from "angular";
import {TradefloorApiService} from "../../js/services/tradefloorApi.service";
import {SimpleModalService} from "../../types/SimpleModalService";
import {getOrderApiErrorDetails} from "../../js/error.utils";
import {AmendOrderRecord} from "../models/AmendOrderRecord";
import {IosServerName, OrderNumbers, OrderRecords} from "../models/OrderRecord";
import {SimulatedOrderRecords} from "../models/simulated/SimulatedOrderRecord";

export class OrderService {

    public static id = "orderService";

    /** @ngInject */
    public constructor(private $http: IHttpService,
                       private confirmationService: ConfirmationService,
                       private confirmationTypes: ConfirmationTypes,
                       private tradefloorApi: TradefloorApiService,
                       private simpleModalService: SimpleModalService) {
    }

    public async cancelOrder(iosServer: IosServerName, orderNumber: number) {
        await this.confirmationService.confirm(this.confirmationTypes.cancelOrder);
        try {
            await this.$http.post(`/tradefloor/api/orders/${iosServer}/${orderNumber}/cancel`, {});
        } catch (error) {
            this.displayError(error, "Cancel Order Error");
        }
    }

    public async cancelSimulatedOrder(orderId: number) {
        await this.confirmationService.confirm(this.confirmationTypes.cancelOrder);
        try {
            await this.$http.post(`/tradefloor/api/simulated-orders/${orderId}/cancel`, {});
        } catch (error) {
            this.displayError(error, "Cancel Order Error");
        }
    }

    public async updateOrder(iosServer: IosServerName, orderNumber: number, change: AmendOrderRecord): Promise<void> {
        const url = `/tradefloor/api/orders/${iosServer}/${orderNumber}/amend`;
        try {
            await this.$http.post(url, change);
        } catch (error) {
            this.displayError(error, "Update Order Error");
        }
    }

    public async updateSimulatedOrder(orderId: number, change: AmendOrderRecord): Promise<void> {
        const url = `/tradefloor/api/simulated-orders/${orderId}/amend`;
        try {
            await this.$http.post(url, change);
        } catch (error) {
            this.displayError(error, "Update Order Error");
        }
    }

    private displayError(httpResp: IHttpPromiseCallbackArg<any>, title: string) {
        const orderErrorDescription = getOrderApiErrorDetails(httpResp);
        if (orderErrorDescription.length > 0) {
            this.simpleModalService.error(null,
                                          `<pre>${orderErrorDescription}</pre>`,
                                          title, "lg");
        }
    }

    public async openOrders(): Promise<OrderRecords> {
        const url = "/tradefloor/api/orders/open";
        const config: IRequestShortcutConfig = {
            ignoreLoadingBar: true
        };
        const response = await this.$http.get<OrderRecords>(url, config);
        return response.data;
    }

    public async simulatedOrders(): Promise<SimulatedOrderRecords> {
        const url = "/tradefloor/api/simulated-orders/open";
        const config: IRequestShortcutConfig = {
            ignoreLoadingBar: true
        };
        const response = await this.$http.get<SimulatedOrderRecords>(url, config);
        return response.data;
    }

    public async openPlacedBrokerOrders(): Promise<OrderNumbers> {
        const url = "/tradefloor/api/orders/open-placed-orders";
        const response = await this.$http.get<OrderNumbers>(url, {ignoreLoadingBar: true});
        return response.data;
    }

    public async openPlacedSimulatedOrders(): Promise<ReadonlyArray<number>> {
        const url = "/tradefloor/api/simulated-orders/open-placed-orders";
        const response = await this.$http.get<ReadonlyArray<number>>(url, {ignoreLoadingBar: true});
        return response.data;
    }
}
